import {minBy, maxBy, find} from 'lodash';
import {MoneyHelper} from "app/lib/moneyHelper";
import {DELIVERY_TIMES} from "app/model/deliveryMethod";
import {Calculate} from "app/lib/calculate";
import {ExchangeRate} from "app/model/exchangeRate";
import {Amount} from "app/model/amount";
import Money from 'js-money';

const MAX_EXAMPLE_VALUE = 100000;

export const normalize = (amount) => {
    const value = Math.min(MAX_EXAMPLE_VALUE, amount.getAmount);
    const currency = amount.getCurrency;

    return Amount.create(Money.fromDecimal((value / 100), currency, Math.ceil));
};

export const getDeliveryFeeRange = (deliveryMethods) => {
    if (!deliveryMethods) {
        return;
    }
    const methodWithSmallestFee = minBy(Object.values(deliveryMethods), (method) => method.fee.standard.getAmount);
    const methodWithBiggestFee = maxBy(Object.values(deliveryMethods), (method) => method.fee.standard.getAmount);
    const formatMoney = (method) => MoneyHelper.format(method.fee.standard.getAmount);
    const currency = methodWithSmallestFee.fee.standard.getCurrency;

    if (methodWithSmallestFee.fee.standard.getAmount === methodWithBiggestFee.fee.standard.getAmount) {
        return methodWithBiggestFee.fee.standard.toString;
    }

    return `${formatMoney(methodWithSmallestFee)} - ${formatMoney(methodWithBiggestFee)} ${currency}`;
};


export const getSmallestDeliveryTime = (deliveryMethods) => {
    if (!deliveryMethods) {
        return;
    }

    for (const time of Object.values(DELIVERY_TIMES)) {
        const method = find(deliveryMethods, (method) => method.deliveryTime === time);

        if (method) {
            return time;
        }
    }

    return null;
};

export const getCalculatedAmountOut = (amountIn, exchange) => {
    return Calculate(amountIn.amount, exchange);
};

export const getDeliberateRate = (rate, difference = .02) => {
    if (!rate) {
        return;
    }

    const resultRate = rate.inversion ?
        (rate.rate + (rate.rate * difference)) :
        (rate.rate - (rate.rate * difference));

    return ExchangeRate.create({...rate, rate: resultRate.toFixed(4)});
};

export const getAmountDifference = (amount1, amount2) => {
    return Amount.createMoney(amount1.getAmount - amount2.getAmount, amount1.getCurrency);
};
